<template>
    <div>
        <ob1-popin-modal2
            :id="modalId"
            :aria-labelledby="modalId+'-details'"
            :show-close-button="!recoveryValue || !recoverySimulator"
        >
            <h3 class="h4 my-1">
                {{ infosRecovery.title }}
            </h3>
            <ob1-message-complementaire v-if="bonusAmount" class="text-mw mb-2" :title="bonusAmount + infosRecovery.message" />
            <ul class="list-unstyled mb-2">
                <li class="text-mw mb-1">
                    <div class="items-list-item highlight">
                        <span class="item-icon" :class="infosRecovery.stepOne.icon" aria-hidden="true" />
                        <p class="mb-0" v-html="infosRecovery.stepOne.text" />
                    </div>
                </li>
                <li class="text-mw mb-1">
                    <div class="items-list-item highlight">
                        <span class="item-icon" :class="infosRecovery.stepTwo.icon" aria-hidden="true" />
                        <p class="mb-0" v-html="infosRecovery.stepTwo.text" />
                    </div>
                    <ul class="list-unstyled mt-1">
                        <li
                            v-for="(item, index) in infosRecovery.processDetails"
                            :key="'process-item-'+index"
                            class="text-mw mb-1"
                        >
                            <div class="items-list-item highlight">
                                <span class="item-icon" :class="item.icon" aria-hidden="true" />
                                <p class="mb-0" v-html="item.text" />
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <ob1-liens-haut-bas
                :button-id="'recovery-more-button'"
                :button-label="infosRecovery.more"
                :collapsed-block-id="'recovery-more-infos'"
                :is-collapsed="true"
            >
                <recovery-details-part
                    v-if="onlineRecovery"
                    class="mb-1"
                    :recovery-details="onlineRecovery"
                />
                <recovery-details-part
                    v-if="storeRecovery"
                    :recovery-details="storeRecovery"
                />
                <recovery-bonus-part
                    v-if="bonus && bonusRecovery"
                    :bonus-details="bonusRecovery"
                    :condition="bonus.condition"
                />
            </ob1-liens-haut-bas>
            <div
                v-if="recoveryValue && recoverySimulator"
                class="modal-footer mt-2"
            >
                <ob1-boutons
                    :is-primary="true"
                    :label="simulatorButtonLabel"
                    data-bs-toggle="modal"
                    :data-bs-target="'#' + 'mobile-recovery-simulator-inside'"
                    data-oevent-label="estimer_votre_mobile_actuel"
                    :data-oevent-action="recoveryValue.tmsAction"
                    :data-oevent-category="recoveryValue.tmsZone"
                />
            </div>
        </ob1-popin-modal2>
        <mobile-recovery-simulator-modal
            v-if="recoveryValue && recoverySimulator"
            modal-id="mobile-recovery-simulator-inside"
            :title="recoverySimulator.title"
            :subtitle="recoverySimulator.subtitle"
            :url="recoveryValue.simulatorUrl"
        />
    </div>
</template>

<script>
import RecoveryBonusPart from "./RecoveryBonusPart.vue";
import RecoveryDetailsPart from "./RecoveryDetailsPart.vue";
import MobileRecoverySimulatorModal from "./MobileRecoverySimulatorModal.vue";

export default {
    name: "MobileRecoveryDetailsModal",
    components: {MobileRecoverySimulatorModal, RecoveryBonusPart, RecoveryDetailsPart},
    props: {
        modalId: {
            type: String,
            required: true
        },
        infosRecovery: {
            type: Object,
            required: true
        },
        onlineRecovery: {
            type: Object,
            default: undefined
        },
        storeRecovery: {
            type: Object,
            default: undefined
        },
        bonusRecovery: {
            type: Object,
            default: undefined
        },
        bonus: {
            type: Object,
            default: undefined
        },
        recoverySimulator: {
            type: Object,
            default: null
        },
        simulatorButtonLabel: {
            type: String,
            required: true
        },
        recoveryValue: {
            type: Object,
            default: null
        },
        bonusAmount: {
            type: String,
            default: null
        },
    }
}
</script>

<style lang="scss">
@import 'ob1_common';

.items-list-item {
    max-width: inherit;
    align-items: inherit;

    .item-icon {
        font-size: px-to-rem(24);
        padding-top: px-to-rem(8);
    }
}

</style>
